import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Image, Button, Form } from 'react-bootstrap';
import './ViewProfile.css';
import NeighbourSidebar from "../../NeighbourSidebar";
import Header from "../../NeighbourHeaderAfterLogin";
import Footer from "../../FooterAfterLogin";
import { Link,useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import API from '../../../Utils/Api';
import loader from '../../../assests/loader.gif';
import { gettoastwarning,gettoastsuccess } from '../../../Utils/Common';
import {validatelocation} from '../../../Utils/validate';

const ViewProfile = () => {
    const navigate = useNavigate();
    const [loading,setLoading] = useState(true);

    const [errors,setErrors] = useState({});

    const [inputs,setInputs] = useState({first_name:'',last_name:'',email:'',contact_number:''});
    const [location,setLocation] = useState([]);
    const [business,setBusiness] = useState([]);
    const [inputsl,setInputsl] = useState({pincode:'',state:'',city:'',town:''});

    const [state, setState] = useState([]);
    const [city, setCity] = useState([]);
    const [town, setTown] = useState([]);

    const [businesschk,setBusinesschk] = useState(1);

    const [businessid, setBusinessid] = useState(1);

  const [isproverify, setIsproverify] = useState(0);

    useEffect(() => {
        document.title = `View Profile | Local Bells`;
        document.getElementById('bodywrap').className = 'neviewpro';

        /* Start get profile */
            API.get('get_user_detail')
                .then(response => {
                    setLoading(false);
                if(response.data.status === false){
                    
                }else{
                  setInputs({
                    first_name:response.data.data.first_name,
                    last_name:response.data.data.last_name,
                    email:response.data.data.email,
                    contact_number:response.data.data.contact_number,
                  });
                  setLocation(response.data.data.location);
                  setBusiness(response.data.data.business);
                }                  
            }).catch(error => {
                setLoading(false); 
            });  
        /* End get profile */

        API.post('get_state')
              .then(response => {
              setState(response.data.data);       
          });

          API.post('get_business_with_user_login')
                .then(response => {
                    setLoading(false);
                if(response.data.status === false){
                    
                }else{
                  setBusinesschk(response.data.data.status);
                  setBusinessid(response.data.data.business_id);
                  setIsproverify(response.data.data.is_profile_verify);
                }                  
            }).catch(error => {
                
            });      

    }, []);

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    /* Start show delete */
    const handleDelete = (id) => {    
        setLoading(true);
        let formData = new FormData(); 
        formData.append('id', id);
        API.post('delete_location', formData)
            .then(response => {
            setLoading(false);
            if(response.data.status === true){
                if(Number(id)===Number(localStorage.getItem('location_id')))
                {
                    localStorage.setItem("location_id", response.data.data.location_id);
                    const loc = `${response.data.data.location_town_name} - ${response.data.data.location_pincode}`;
                    localStorage.setItem("location", loc);
                }

                gettoastsuccess(response.data.message, '/neighbour/view-profile');
                setLoading(false);
            }else{
              gettoastwarning(response.data.message, '');
              setLoading(false);
            }                  
        }).catch(error => {
             
        }); 
    }
    /* End show delete varification modal */

/* Start Value set */
const handleInputChangeMo = (event) => {
  event.persist();
  const { name, value } = event.target;

  // Allow only numbers (0–9)
  const regex = /^[0-9]*$/;

  if (regex.test(value)) {
    setInputsl(inputsl => ({ ...inputsl, [name]: value }));
    //getpicode_town(value);
  }      
}

const getCity = (event) => {     
      event.preventDefault();
      setInputsl(inputsl => ({...inputsl, [event.target.name]: event.target.value})); 

      setTown([]);  

      var st='city';
      var st_val='';
       setInputsl(inputsl => ({...inputsl, [st]: st_val})); 

       var ct='town';
      var ct_val='';
       setInputsl(inputsl => ({...inputsl, [ct]: ct_val})); 

      let formData = new FormData(); 
          formData.append('state_id', event.target.value);
          API.post('get_city', formData)
                    .then(response => {
                      
                    if(response.data.status === true){
                     setCity(response.data.data);  
                    }else{
                        
                         
                    }
                  }).catch(error => {
                      
              }); 

  }

  const getTown = (event) => {     
      event.preventDefault();
      setInputsl(inputsl => ({...inputsl, [event.target.name]: event.target.value})); 

      setTown([]);  

       var ct='town';
      var ct_val='';
       setInputsl(inputsl => ({...inputsl, [ct]: ct_val})); 

      let formData = new FormData(); 
          formData.append('city_id', event.target.value);
          API.post('get_town', formData)
                    .then(response => {
                      
                    if(response.data.status === true){
                     setTown(response.data.data);  
                     var ct1 = 'town';
                      var ct_val1 = response.data.extra_data.town_id;
                      setInputsl(inputsl => ({ ...inputsl, [ct1]: ct_val1 }));

                      var pin1 = 'pincode';
                      var pin_val1 = response.data.extra_data.pincode;
                      setInputsl(inputsl => ({ ...inputsl, [pin1]: pin_val1 }));
                    }else{
                           
                    }
                  }).catch(error => {
                      
              }); 
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validatelocation(inputsl);
     const noErrors = Object.keys(validationErrors).length === 0;
        setErrors({});
        setErrors(validationErrors);
        
        if(noErrors){
                setLoading(true);
            
            let formData = new FormData(); 
            Object.keys(inputsl).forEach((key) => {
                formData.append(key, inputsl[key]);
            });
            API.post('add_location', formData)
              .then(response => {
              if(response.data.status === false){
                //setError(response.data.message);
                setLoading(false); 
                gettoastwarning(response.data.message,'');
              }else{
                 setLoading(false);
                 gettoastsuccess(response.data.message,'/neighbour/view-profile');
              }                  
            }).catch(error => {
               setLoading(false);
               gettoastwarning("Something went wrong. Please try again later.",'');
                //setError("Something went wrong. Please try again later.");
            });
        }
    //navigate('/neighbour/login');
  };
const getCat = (event) => {     
      event.preventDefault();
      setInputsl(inputsl => ({...inputsl, [event.target.name]: event.target.value})); 
      get_town_picode(event.target.value);
}
const get_town_picode = (id) => {
        let formData = new FormData(); 
         formData.append('town_id', id);
        API.post('get_town_pincode',formData)
            .then(response => {
              
            if(response.data.status === true){
                if(response.data.data.city_id!=='')
                {
                    var pincode_label='pincode';
                    var pincode_val=response.data.data.pincode;
                    setInputsl(inputsl => ({...inputsl, [pincode_label]: pincode_val}));
                }
            }else{
                    
            }
          }).catch(error => {
              
      });
}

const getpicode_town = () => {
      if(inputs.pincode!=='')
      {
            let formData = new FormData(); 
             formData.append('pin_code', inputsl.pincode);
            API.post('get_pincode_town',formData)
                .then(response => {
                  
                if(response.data.status === true){
                    if(response.data.data.city_id!=='' && response.data.data.city_id!=='')
                    {
                        setCity(response.data.data.city);
                        setTown(response.data.data.town);
                        var state_label='state';
                        var state=response.data.data.state_id;
                        setInputsl(inputsl => ({...inputsl, [state_label]: state}));

                        var city_label='city';
                        var city=response.data.data.city_id;
                        setInputsl(inputsl => ({...inputsl, [city_label]: city}));

                        var town_label='town';
                        var town=response.data.data.town_id;
                        setInputsl(inputsl => ({...inputsl, [town_label]: town}));

                        var town_text=response.data.data.town_name;
                        var town_name_lbl="town_name";
                        setInputsl(inputsl => ({ ...inputsl, [town_name_lbl]: town_text }));
                    }else{
                        setCity([]);
                            setTown([]);
                            var state_label3 = 'state';
                            var state3 = '';
                            setInputsl(inputsl => ({ ...inputsl, [state_label3]: state3 }));

                            var city_label3 = 'city';
                            var city3 = '';
                            setInputsl(inputsl => ({ ...inputsl, [city_label3]: city3 }));

                            var town_label3 = 'town';
                            var town3 = '';
                            setInputsl(inputsl => ({ ...inputsl, [town_label3]: town3 }));

                            var town_text3='';
                            var town_name_lbl3="town_name";
                            setInputsl(inputsl => ({ ...inputsl, [town_name_lbl3]: town_text3 }));
                    }
                }else{
                  setCity([]);
                    setTown([]);
                    var state_label1 = 'state';
                    var state1 = '';
                    setInputsl(inputsl => ({ ...inputsl, [state_label1]: state1 }));

                    var city_label1 = 'city';
                    var city1 = '';
                    setInputsl(inputsl => ({ ...inputsl, [city_label1]: city1 }));

                    var town_label1 = 'town';
                    var town1 = '';
                    setInputsl(inputsl => ({ ...inputsl, [town_label1]: town1 }));

                    var town_text1='';
                        var town_name_lbl1="town_name";
                        setInputsl(inputsl => ({ ...inputsl, [town_name_lbl1]: town_text1 }));      
                }
              }).catch(error => {
                  
          });
      }else{
        setCity([]);
            setTown([]);
            var state_label2 = 'state';
            var state2 = '';
            setInputsl(inputsl => ({ ...inputsl, [state_label2]: state2 }));

            var city_label2 = 'city';
            var city2 = '';
            setInputsl(inputsl => ({ ...inputsl, [city_label2]: city2 }));

            var town_label2 = 'town';
            var town2 = '';
            setInputsl(inputsl => ({ ...inputsl, [town_label2]: town2 }));

            var town_text2='';
            var town_name_lbl2="town_name";
            setInputsl(inputsl => ({ ...inputsl, [town_name_lbl2]: town_text2 }));
      }
}

const busred = () => {
    localStorage.setItem("business_id", businessid);
    localStorage.setItem("is_profile_verify_buss", isproverify);
    
      window.location.href = '/business/add-new-business';
  }

    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <NeighbourSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <Row>
                                    <Col md={12} lg={12} xl={12} xxl={4}>
                                        <div className='white-box'>
                                            <div className="d-flex align-items-start justify-content-between gap-3">
                                                <h3>Basic details</h3>
                                                <Link to="#" onClick={() => navigate(-1)} className='cross-up d-block d-md-none'>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid crosy" alt="wp" />
                                                </Link>
                                            </div>
                                            


                                            <div className='mb-4 mt-4'>
                                                <h6>Name</h6>
                                                <h6 className='fw-500'>{inputs.first_name} {inputs.last_name}</h6>
                                            </div>
                                            <div className='mb-4'>
                                                <h6>Email</h6>
                                                <h6 className='fw-500'>{inputs.email}</h6>
                                            </div>
                                            <div className='mb-4'>
                                                <h6>Contact Number</h6>
                                                <h6 className='fw-500'>{inputs.contact_number}</h6>
                                            </div>
                                            <Link to="/neighbour/edit-profile" className='blue-link ep-link'>Edit profile</Link>
                                        </div>
                                    </Col>
                                    <Col md={12} lg={12} xl={12} xxl={4}>
                                        <div className='white-box'>
                                            <div className='mf-top mb-4'>
                                                <h5 className='fw-500 '>My Locations</h5>
                                                <Link to="/neighbour/invite-a-neighbor">Invite</Link>
                                            </div>
                                            {location && location.map((val, index) => {
                                                return (    
                                                        <div className='mypro-box flex-row gap-3'>
                                                            <div className='mypro-left'>
                                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/city.webp'} className="img-fluid" alt="city" />
                                                                <h6 className='fw-500'>{val.state_name} {val.city_name} {val.town_name} - {val.pincode}</h6>
                                                            </div>
                                                            <div>
                                                                <Link to="#" onClick={() =>handleDelete(val.id)} className='del-link'>
                                                                     <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/del-whi.webp'} className="img-fluid" alt="del-whi" />
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    );
                                             })}
                                            {/*<div className='mypro-box'>
                                                <div className='mypro-left'>
                                                    <Image src="../assets/images/city.webp" className="img-fluid" alt="city" />
                                                    <h6 className='fw-500'>Veera Selfie Mirror - Nasik 422013</h6>
                                                </div>
                                                <div>
                                                    <Link to="/" className='blue-icn-btn share-link'><h6>Share</h6> <Image src="../assets/images/share-wh.webp" className="img-fluid" alt="share-wh" /> </Link>
                                                </div>
                                            </div>*/}
                                            {/*<h5 className='fw-500 mt-4 mb-4'>Add Profiles</h5>*/}
                                            <div className='ap-box'>
                                                <Row>
                                                 <Col md={12}>
                                                <Link to="" className='anc-link' onClick={handleShow}>
                                                    <div>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/add-wh.webp'} className="img-fluid" alt="add-wh" />
                                                        <h6>Add new Location</h6>
                                                    </div>
                                                </Link>
                                                </Col>

                                                {businesschk !== 1 ? (
                                                    <Col md={12} className="mt-3">
                                                  <Link to="/neighbour/switch-business-profile" className="anb-link" >
                                                    <div>
                                                      <Image
                                                        src={process.env.REACT_APP_BASE_URL + 'assets/images/add-wh.webp'}
                                                        className="img-fluid"
                                                        alt="add-wh"
                                                      />
                                                      <h6>Add new business</h6>
                                                    </div>
                                                  </Link>
                                                   </Col>
                                                ) : null}
                                            </Row>
                                            </div>
                                        </div>
                                    </Col>

                                    {business.length > 0 && (
                                    <Col md={12} lg={12} xl={12} xxl={4}>
                                        <div className='white-box'>
                                            <div className='mf-top mb-4'>
                                                <h5 className='fw-500 '>My Bussiness</h5>
                                            
                                            </div>
                                            {business && business.map((val, index) => {
                                                return (    
                                                        <div className='mypro-box flex-row gap-3'>
                                                            <div className='mypro-left'>
                                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/business.webp'} className="img-fluid" alt="city" />
                                                                <h6 className='fw-500'>{val.business_name}</h6>
                                                            </div>
                                                           
                                                        </div>
                                                    );
                                             })}
                                           <div className='ap-box'>
                                                <Link to="#" className='anc-link' onClick={(e) => { e.preventDefault(); busred(); }}>
                                                    <div>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/add-wh.webp'} className="img-fluid" alt="add-wh" />
                                                        <h6>Add new Business</h6>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                    </Col>
                                    )}
                                </Row>
                                <div className='footer-main footer'>
                                    <Footer />                                
                                </div>                                 
                                <Modal
                                    show={show}
                                    onHide={handleClose}
                                    backdrop="static"
                                    keyboard={false}
                                    centered
                                    className='add-city-modal'
                                >
                                    <Modal.Header closeButton>
                                        <h3>Add a New Location</h3>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Form onSubmit={handleSubmit}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className='d-none'>Pin code</Form.Label>
                                                <Form.Control type="text" placeholder="Pin code" name="pincode" onChange={handleInputChangeMo} onBlur={getpicode_town} value={inputsl.pincode} maxLength={6}/>
                                                  
                                            </Form.Group>
                                             {errors.pincode && (<p className="text-danger">{errors.pincode}</p>)}
                                            <Form.Select aria-label="Default select example" name="state" onChange={getCity} value={inputsl.state}>
                                                <option value="">State</option>
                                                {state && state.map((val, index) => {
                                                   return (
                                                        <option value={val.id}>{val.name}</option>
                                                    )
                                                 })}
                                            </Form.Select>
                                            {errors.state && (<p className="text-danger">{errors.state}</p>)} 
                                            <Form.Select aria-label="Default select example" name="city" onChange={getTown} value={inputsl.city}>
                                                <option value="">City</option>
                                                {city && city.map((val, index) => {
                                                   return (
                                                        <option value={val.id}>{val.name}</option>
                                                    )
                                                  })}
                                            </Form.Select>
                                            {errors.city && (<p className="text-danger">{errors.city}</p>)}
                                            <Form.Select aria-label="Default select example" name="town" onChange={getCat} value={inputsl.town}>
                                                <option value="">Locality</option>
                                                {town && town.map((val, index) => {
                                                    return ( 
                                                        <option value={val.id}>{val.name}</option>
                                                     )
                                                 })}
                                            </Form.Select>
                                            {errors.town && (<p className="text-danger">{errors.town}</p>)}
                                            <Button type="submit" className='blue-btn'>Add Location</Button>
                                        </Form>
                                    </Modal.Body>
                                </Modal>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            {loading && (
               <div className="loadingClass">
                <img src={loader} alt="loader"/>
              </div>
               )}
        </>
    )
}

export default ViewProfile;


